export default __webpack_public_path__ + "static/media/noaskmedium.a6405795.png";